export default "__VITE_ASSET__BfxnwbVH__"